import script from "./ItemsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemsList.vue?vue&type=script&setup=true&lang=ts"

import "./ItemsList.vue?vue&type=style&index=0&id=72829064&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72829064"]])

export default __exports__